module.exports = __webpack_public_path__ + "img/quote-SMT@ico.3a67bb62.png";